<template>
  <div>
    <div class="checkout">
      <div class="container">
        <div class="row pb-4">
          <div class="col-lg-12">
            <h2 class="checkout-title" style="font-size: 4rem">
              Creazione nuovo caso clinico


            </h2>
            <p class="mb-2">Gentile Utente,<br>

              Le informazioni sensibili che sta inserendo riguardano un soggetto terzo non facente parte del gruppo.
              Le chiediamo la cortesia di prestare particolare attenzione al momento della fornitura dei dati, per
              evitare che il Suo paziente risulti in qualche modo identificabile e di aver ottenuto il consenso per
              l'utilizzo delle relative informazioni e immagini.</p>
            <LoadedComponent :loading="loading" />

            <AlertComponent :message="successMessageFirstStep" :alert-type="'success'" />
            <AlertComponent :message="errorMessage" :alert-type="'danger'" />

            <ul class="nav nav-tabs nav-tabs-bg" id="tabs-1" role="tablist">
              <li class="nav-item">
                <a :class="firstStep ? 'nav-link active' : 'nav-link'" id="tab-1-tab" data-toggle="tab" href="#tab-1"
                  role="tab" aria-controls="tab-1" aria-selected="true">Dati del caso</a>
              </li>
              <li class="nav-item" v-if="!firstStep">
                <a :class="firstStep ? 'nav-link' : 'nav-link active'" id="tab-3-tab" data-toggle="tab" href="#tab-3"
                  role="tab" aria-controls="tab-3" aria-selected="true">Carica allegati</a>
              </li>
              <li class="nav-item" v-if="!firstStep">
                <a class="nav-link" id="tab-2-tab" data-toggle="tab" href="#tab-2" role="tab" aria-controls="tab-2"
                  aria-selected="true">Ordinamento allegati</a>
              </li>

              <li class="nav-item" v-if="!firstStep">
                <a class="nav-link" id="tab-4-tab" data-toggle="tab" href="#tab-4" role="tab" aria-controls="tab-3"
                  aria-selected="true">Carica la copertina</a>
              </li>
            </ul>

            <div class="tab-content tab-content-border" id="tab-content-1">
              <div :class="firstStep ? 'tab-pane fade show active' : 'tab-pane fade'
                " id="tab-1" role="tabpanel" aria-labelledby="tab-1-tab">
                <form class="pt-2 pr-4 pl-4" id="form-date-submit" @submit.prevent="create_clinical_case">
                  <h4 class="pb-2">
                    <small>
                      Inserisci le informazioni del tuo caso e fai click in
                      basso a destra per salvarle
                    </small>
                  </h4>
                  <div class="row">
                    <div class="col-sm-8">
                      <label for="nome_caso">Nome del caso *</label>
                      <input type="text" class="form-control" name="nome" id="nome_caso"
                        placeholder="Aggiorna il nome del caso" v-model="formClinicalCase.name" />

                      <div class="alert alert-danger" v-if="errors.name">
                        {{ errors.name[0] }}
                      </div>
                    </div>
                    <!-- End .col-sm-6 -->
                    <div class="col-sm-4">
                      <label for="nome_caso">Data pubblicazione *</label>
                      <input type="date" class="form-control" name="data_pubblicazione" id="data_pubblicazione_edit"
                        v-model="formClinicalCase.publish_date" required />
                      <div class="alert alert-danger" v-if="errors.publish_date">
                        {{ errors.publish_date[0] }}
                      </div>
                    </div>

                    <div :class="rowClassIfCompany">
                      <label for="categorie_mediche_edit" class="form-label">Categoria *</label>
                      <select class="form-control" id="categorie_mediche_edit" name="id_categoria_medica"
                        v-model="formClinicalCase.category_medical_id" readonly>
                        <option :value="null" selected>
                          Seleziona una categoria medica
                        </option>
                        <option v-for="category in categoryMedical" :key="category.id" :value="category.id">
                          {{ category.name }}
                        </option>
                      </select>
                      <div class="alert alert-danger" v-if="errors.category_medical_id">
                        {{ errors.category_medical_id[0] }}
                      </div>
                    </div>

                    <div :class="rowClassIfCompany">
                      <label for="patologia_edit" class="form-label">Patologia *</label>
                      <select class="form-control" id="patologia_edit" name="id_patologia"
                        v-model="formClinicalCase.patology_id" required>
                        <option :value="null" selected>
                          Seleziona una patologia
                        </option>
                        <option v-for="patology in patologies" :key="patology.id" :value="patology.id">
                          {{ patology.name }}
                        </option>
                      </select>

                      <div class="alert alert-danger" v-if="errors.patology_id">
                        {{ errors.patology_id[0] }}
                      </div>
                    </div>

                    <div :class="rowClassIfCompany">
                      <label for="company_edit" class="form-label">Azienda
                      </label>
                      <select class="form-control" id="company_edit" name="company_id"
                        v-model="formClinicalCase.company_id" required>
                        <option :value="null" selected>Nessuno sponsor</option>
                        <option v-for="company in companies" :key="company.id" :value="company.id">
                          {{ company.name }}
                        </option>
                      </select>

                      <div class="alert alert-danger" v-if="errors.company_id">
                        {{ errors.company_id[0] }}
                      </div>
                    </div>

                    <div class="col">
                      <label for="distretto_anatomico" class="form-label">Distretto Anatomico *</label>

                      <select class="form-control" id="distretto_anatomico" name="id_distretto"
                        v-model="formClinicalCase.anatomical_district_id" required>
                        <option :value="null" selected>
                          Seleziona un distretto anatomico
                        </option>
                        <option v-for="anatomical in anatomicalDistrict" :key="anatomical.id" :value="anatomical.id">
                          {{ anatomical.name }}
                        </option>
                      </select>

                      <div class="alert alert-danger" v-if="errors.anatomical_district_id">
                        {{ errors.anatomical_district_id[0] }}
                      </div>
                    </div>

                    <div class="col" v-if="firstStep">
                      <label for="linkedin_publish" class="form-label">Pubblicazione su linkedin *</label>

                      <select class="form-control" id="linkedin_publish" name="copertina"
                        v-model="formClinicalCase.status_linkedin">
                        <option :value="null" disabled selected>
                          Seleziona se pubblicare su linkedin
                        </option>
                        <option value="0">Non pubblicare su linkedin</option>
                        <option value="1">Pubblica su linkedin</option>
                      </select>

                      <div class="alert alert-danger" v-if="errors.status_linkedin">
                        {{ errors.status_linkedin[0] }}
                      </div>
                    </div>

                    <div class="col" v-if="firstStep">
                      <label for="linkedin_publish" class="form-label">Anonimato del caso *</label>
                      <select class="form-control" id="linkedin_publish" name="copertina"
                        v-model="formClinicalCase.anonymous">
                        <option :value="null" disabled selected>
                          Scegli se rendere il caso anonimo
                        </option>
                        <option value="0">Pubblica caso normalmente</option>
                        <option value="1">Rendi il caso anonimo</option>
                      </select>

                      <div class="alert alert-danger" v-if="errors.anonymous">
                        {{ errors.anonymous[0] }}
                      </div>
                    </div>

                    <div class="col" v-if="firstStep">
                      <label for="notification_type" class="form-label">Tipo di notifica *</label>
                      <select class="form-control" id="notification_type" name="notification_type"
                        v-model="formClinicalCase.notification_type">
                        <option value="email">Notifica via email</option>
                        <option value="sms">Notifica via sms</option>
                      </select>

                      <div class="alert alert-danger" v-if="errors.notification_type">
                        {{ errors.notification_type[0] }}
                      </div>
                    </div>

                    <div class="col-md-12">
                      <label for="descrizione">Descrizione del post *</label>
                      <textarea class="form-control" id="descrizione" rows="3" name="descrizione"
                        placeholder="Spiegazione del tuo post" v-model="formClinicalCase.description"></textarea>

                      <div class="alert alert-danger" v-if="errors.description">
                        {{ errors.description[0] }}
                      </div>
                    </div>

                    <div class="col-md-9" v-if="firstStep">
                      <label for="" class="form-label">Utenti a cui notificare il caso *</label>
                      <Select2 v-model="formClinicalCase.notifications" :options="users" :settings="{
                        multiple: true
                      }" :placeholder="'Seleziona gli utenti'" style="width: 100% !important;" />
                      <div class="alert alert-danger" v-if="errors.notifications">
                        {{ errors.notifications[0] }}
                      </div>
                    </div>
                    <div class="col-md-3">
                      <label for="is_public" class="form-label">Pubblicazione caso *</label>
                      <select class="form-control" id="is_public" v-model="formClinicalCase.is_public"
                        @change="setAllUser">
                        <option :value="null" disabled selected>
                          Seleziona la tipologia di accesso al caso
                        </option>
                        <option :value="true">Caso pubblico</option>
                        <option :value="false">Caso chiuso agli invitati</option>
                      </select>

                      <div class="alert alert-danger" v-if="errors.is_public">
                        {{ errors.is_public[0] }}
                      </div>
                    </div>

                    <div class="col-md-12" v-if="firstStep">
                      <label for="custom_message">Personalizza la tua notifica</label>
                      <textarea class="form-control" id="custom_message" rows="3" name="descrizione"
                        placeholder="Testo del messaggio che verrà inserito nella mail di notifica"
                        v-model="formClinicalCase.custom_message"></textarea>
                    </div>

                    <div class="alert alert-danger" v-if="errors.custom_message">
                      {{ errors.custom_message[0] }}
                    </div>
                  </div>

                  <div class="row flex-column pb-2 pl-2 pr-2">
                    <div class="flex-row">
                      <button type="submit" class="btn btn-primary float-right">
                        Salva le info <i class="las la-save"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </div>

              <div class="tab-pane fade show" id="tab-2" role="tabpanel" aria-labelledby="tab-2-tab">
                <div class="row pt-4 pr-4 pl-4">
                  <div class="col-md-12">
                    <h2 class="checkout-title" style="font-size: 2rem">
                      Ordinamento file <br /><small>Per ordinare i file clicca e trascina il file
                        nell'ordine desiderato.</small>
                    </h2>
                    <form @submit.prevent="save_order">
                      <ul ref="sortableList" class="list-group">
                        <li v-for="(item, index) in attachments" :key="item.id" class="list-group-item mb-2">
                          <div class="float-right">
                            <button type="btn btn-link " @click="deleteAttachment(item.id, index)">
                              Elimina il file
                            </button>
                          </div>
                          <input type="hidden" name="order[]" class="order_class" v-model="item.id" />
                          <div class="row">
                            <input type="text" :value="item.name" :id="'attachments-rename-' + item.id"
                              class="form-control w-50" />
                            <button type="button" class="btn btn-link text-dark ml-2" @click="rename(item.id)">
                              <i class="las la-pen-fancy"></i> Rinonima
                            </button>
                          </div>
                        </li>
                      </ul>
                      <div class="row flex-column pb-2 pl-2 pr-2">
                        <div class="flex-row">
                          <button type="submit" class="btn btn-primary float-right">
                            Salva l'ordinamento <i class="las la-save"></i>
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <div :class="firstStep ? 'tab-pane fade' : 'tab-pane fade show active '
                " id="tab-3" role="tabpanel" aria-labelledby="tab-3-tab">
                <div class="row pt-4 pr-4 pl-4">
                  <div class="col-md-12">
                    <input type="hidden" id="category_id" value="1" />
                    <h2 class="checkout-title" style="font-size: 2rem">
                      Carica allegati <br /><small>
                        Qui puoi caricare gli allegati e concludere la
                        pubblicazione del caso cliccando su <i>Invia</i> in
                        basso.
                      </small>
                    </h2>
                    <!-- End .checkout-title -->
                    <form @submit.prevent="upload_attachments">
                      <div class="input-group mb-3">
                        <div class="custom-file">
                          <input type="file" class="custom-file-input" name="files[]" ref="fileInput"
                            @change="handleFileUpload" id="fileInput" aria-describedby="inputGroupFileAddon01"
                            multiple />
                        </div>
                        <label class="custom-file-label text-center labels-files" for="fileInput" id="labelsfiles">{{
                          nameFiles }}
                        </label>
                      </div>

                      <!--d-none -->
                      <a href="#tab-1" id="cover-neurohub" class="btn btn-link d-none" role="tab" aria-controls="tab-1"
                        aria-selected="true" data-toggle="tooltip" data-placement="left"
                        title="Puoi ricontrallare i dati del tuo caso e scegliere una copertina fra le immagini che hai appena caricato">Fra
                        le immagini che hai appena caricato vuoi dare una
                        copertina al caso clinico? Se si clicca qui.</a>
                      <div class="row flex-column pb-2 pl-2 pr-2">
                        <div class="flex-row">
                          <button type="submit" class="btn btn-primary float-right">
                            Salva i nuovi file <i class="las la-save"></i>
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <div class="tab-pane fade show" id="tab-4" role="tabpanel" aria-labelledby="tab-4-tab">
                <div class="row pt-4 pr-4 pl-4">
                  <div class="col-md-12">
                    <h2 class="checkout-title" style="font-size: 2rem">
                      Carica la copertina del caso <br /><small>Seleziona il tuo file
                      </small>
                    </h2>
                    <!-- End .checkout-title -->
                    <form>
                      <div class="input-group mb-3">
                        <div class="custom-file">
                          <input type="file" class="custom-file-input" name="cover" ref="fileInputCover"
                            @change="handleFileUploadCover" id="fileInputCover" aria-describedby="inputGroupFileAddon01"
                            accept="image/png, image/jpeg" />
                        </div>
                        <label class="custom-file-label text-center labels-files" for="fileInputCover"
                          id="labelsfiles">{{ nameFiles }}
                        </label>
                      </div>

                      <div class="d-flex justify-content-center" v-if="coverAttachment !== null">
                        <img :src="coverAttachment.path" :alt="coverAttachment.name" class="img-thumbnail" />
                      </div>
                      <div class="text-center mt-2" v-if="coverAttachment !== null">
                        <button type="button" class="btn btn-danger" @click="deleteAttachment(this.coverAttachment.id)">
                          <i class="las la-trash"></i>
                        </button>
                      </div>

                      <!--d-none -->
                      <a href="#tab-1" id="cover-neurohub" class="btn btn-link d-none" role="tab" aria-controls="tab-1"
                        aria-selected="true" data-toggle="tooltip" data-placement="left"
                        title="Puoi ricontrallare i dati del tuo caso e scegliere una copertina fra le immagini che hai appena caricato">Fra
                        le immagini che hai appena caricato vuoi dare una
                        copertina al caso clinico? Se si clicca qui.</a>
                      <div class="row flex-column pb-2 pl-2 pr-2">
                        <div class="flex-row"></div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <button type="button" class="btn btn-outline-primary-2 btn-order btn-block mt-4" data-toggle="modal"
              data-target="#confirm-publish" v-if="!firstStep && attachments.length > 0">
              <span class="btn-text">Invia</span>
              <span class="btn-hover-text">Pubblica il caso</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" tabindex="-1" role="dialog" id="confirm-publish">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Conferma pubblicazione</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="close-modal-delete-news">
            <span aria-hidden="true"><i class="icon-close"></i></span>
          </button>
        </div>
        <div class="modal-body">
          <div class="m-4">
            <p>
              Sei sicuro di voler pubblicare il caso? Se hai scelto di fare una
              pubblicazione linkedin verrai indirizzato su linkedin. In caso
              contrario verranno inviate subito le notifiche agli utenti.
            </p>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-link" data-dismiss="modal" aria-label="Close">
            Annulla
          </button>
          <button type="button" class="btn btn-outline-primary" @click="publish">
            Pubblica
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import httpauth from "@/services/httpauth.js";
import LoadedComponent from "@/components/LoadedComponent.vue";
import httpservices from "@/services/httpservices.js";
import Select2 from "vue3-select2-component";
import Sortable from "sortablejs";
import router from "@/router";
import $ from "jquery";
import { useAuth } from "@/stores/auth.js";
import AlertComponent from "@/components/AlertComponent.vue";
import { useToast } from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
window.jQuery = $;
window.$ = $;
export default {
  name: "CreateClinicalCase",

  components: {
    Select2,
    LoadedComponent,
    AlertComponent,
  },
  props: {},
  data() {
    return {
      patologies: [],
      categoryMedical: [],
      anatomicalDistrict: [],
      successMessageFirstStep: "",
      errors: [],
      coverAttachment: null,
      users: [],
      errorMessage: "",
      covers: [],
      attachments: [],
      firstStep: true,
      slug: "",
      clinicalCaseId: 0,
      userCompany: false,
      rowClassIfCompany: "col-md-6",
      companies: [],
      loading: false,
      nameFiles: "Scegli i file (MAX 1 GIGA)",
      formClinicalCase: {
        name: "",
        publish_date: "",
        category_medical_id: null,
        patology_id: null,
        anatomical_district_id: null,
        description: "",
        cover: 0,
        notifications: [],
        custom_message: "",
        status_linkedin: 0,
        company_id: null,
        notification_type: "email",
        selectedFiles: {},
        anonymous: null,
        is_public: true,
      },
    };
  },
  mounted() {
    this.fetchCategoryMedical();
    this.fetchPatology();
    this.fetchAtomicalDistrict();
    this.fetchUsers();
    if (location.href.includes("concludi-caso"))
    {
      this.firstStep = false;
      var url = window.location.pathname;
      var segments = url.split("/");
      const slug = segments[segments.length - 1];
      this.loadClinicalCase(slug);
    }
  },
  created() {
    const auth = useAuth();
    if (auth.user.company_id == null)
    {
      this.rowClassIfCompany = "col-md-4";
      this.loadCompanies();
    } else
    {
      this.formClinicalCase.company_id = auth.company_id;
    }
  },
  methods: {
    setAllUser() {
      if (this.formClinicalCase.is_public == false)
      {
        this.users.shift();
        return;
      }
      this.users.unshift({ id: "All", text: "A tutti gli utenti" });
    },
    async loadClinicalCase(slug) {
      await httpauth
        .get("/casi-clinici/edit/" + slug, [
          {
            params: { slug: this.slug }, // Passa l'ID come oggetto nel campo 'data'
          },
        ])
        .then((response) => {
          var data = response.data.data;
          this.formClinicalCase = data;
          this.clinicalCaseId = this.formClinicalCase.id;
          this.loadAttachment(this.formClinicalCase.id);
          if (this.formClinicalCase.category_medical_id == 3)
          {
            this.formClinicalCase.notifications =
              response.data.data.notifications.user;
          } else
          {
            this.formClinicalCase.notifications = [];
          }

          this.loading = false;
          // Gestisci l'array di oggetti come desiderato
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
          this.errors = error.response.data.errors;
        });
    },
    async loadAttachment(model_id) {
      const formData = {
        model: "activity",
        model_id: model_id,
      };
      await httpauth
        .post("/attachments/show", formData)
        .then((response) => {
          var data = response.data.data;
          this.attachments = data;
          this.loading = false;
          const sortableList = this.$refs.sortableList;
          new Sortable(sortableList, {
            animation: 150,
            onEnd: (event) => {
              const movedItem = this.attachments.splice(event.oldIndex, 1)[0];
              this.attachments.splice(event.newIndex, 0, movedItem);
            },
          });
          // Gestisci l'array di oggetti come desiderato
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
        });
    },
    async upload_attachments() {
      this.loading = true;
      await httpservices
        .uploadAttachments(
          this.selectedFiles,
          this.clinicalCaseId,
          "activity",
          1,
          1
        )
        .then((response) => {
          this.nameFiles = "Scegli i file (MAX 1 GIGA)";
          this.loading = false;
          const $toast = useToast();
          $toast.open({
            message: response.data.message,
            type: "success",
            position: "top-right",
            // all of other options may go here
          });

          this.attachments = response.data.data;
          const sortableList = this.$refs.sortableList;
          new Sortable(sortableList, {
            animation: 150,
            onEnd: (event) => {
              const movedItem = this.attachments.splice(event.oldIndex, 1)[0];
              this.attachments.splice(event.newIndex, 0, movedItem);
            },
          });
          return;
        })
        .catch(() => {
          this.loading = false;
          this.error = "Gli allegati non sono stati caricati";
        });
    },
    async handleFileUploadCover(event) {
      const maxSize = 1 * 512 * 512 * 512;
      const file = event.target.files[0];
      const totalSize = file.size;
      if (totalSize <= maxSize)
      {
        const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
        if (allowedTypes.includes(file.type))
        {
          this.loading = true;
          const formData = new FormData();
          formData.append("model", "activity");
          formData.append("model_id", this.clinicalCaseId);
          formData.append("cover", file);
          await httpauth
            .post("/attachments/cover/store", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              const $toast = useToast();
              this.loading = false;
              $toast.open({
                message: response.data.message,
                type: "success",
                position: "top-right",
              });
              this.coverAttachment = response.data.data;
            })
            .catch((error) => {
              if (error.response.message.cover[0])
              {
                const $toast = useToast();
                $toast.open({
                  message: error.response.message.cover[0],
                  type: "danger",
                  position: "top-right",
                  // all of other options may go here
                });
              }
            });
        }
      }
    },
    async deleteAttachment(attachmentId, index) {
      httpservices
        .deleteAttachment(attachmentId)
        .then((response) => {
          const $toast = useToast();
          $toast.open({
            message: response.data.message,
            type: "info",
            position: "top-right",
            // all of other options may go here
          });

          if (index >= 0)
          {
            this.attachments.splice(index, 1);
          } else
          {
            this.coverAttachment = null;
          }
        })
        .catch((error) => {
          if (error.response.message)
          {
            this.error = error.response.message;
          }
        });
    },
    handleFileUpload(event) {
      const maxSize = 1 * 1024 * 1024 * 1024;
      const files = Array.from(event.target.files);
      const totalSize = files.reduce(
        (accumulator, file) => accumulator + file.size,
        0
      );
      const validFiles = [];
      if (totalSize <= maxSize)
      {
        const allowedTypes = [
          "application/pdf",
          "application/msword",
          "application/vnd.ms-office",
          "video/mp4",
          "image/jpeg",
          "image/png",
          "image/jpg",
          "application/dicom",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ];
        Array.from(files).forEach((file) => {
          // Esegui l'azione desiderata su ogni file
          if (
            !allowedTypes.includes(file.type) ||
            !httpservices.checkDicom(file)
          )
          {
            alert(
              "Per favore seleziona un file valido (PDF/DOC/DOCX/JPEG/JPG/PNG/MP4/DCM)."
            );
            this;
            return;
          }
          validFiles.push(file.name);
        });

        this.selectedFiles = files;
        this.nameFiles = validFiles.join(", ");
      } else
      {
        alert("La dimensione totale dei file supera 1 GB");
      }
    },
    async fetchCategoryMedical() {
      await httpservices
        .getCategoryMedical()
        .then((response) => {
          this.categoryMedical = response.data.data;
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
    async loadCompanies() {
      await httpservices
        .getCompany()
        .then((response) => {
          this.companies = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async fetchPatology() {
      await httpservices
        .getPatology()
        .then((response) => {
          this.patologies = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async fetchAtomicalDistrict() {
      await httpservices
        .getAnatomicalDistrict()
        .then((response) => {
          this.anatomicalDistrict = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async fetchAttachments(modelId) {
      await this.getAttachments("activity", modelId)
        .then((response) => {
          this.attachments = response.data.data;
          this.firstStep = false;
        })
        .catch(() => { });
    },
    async create_clinical_case() {
      if (this.firstStep)
      {
        await httpauth
          .post("/casi-clinici/store-first-step", this.formClinicalCase)
          .then((response) => {
            //this.successMessageFirstStep = response.data.message;
            this.clinicalCaseId = response.data.data.id;
            this.slug = response.data.data.slug;
            this.firstStep = false;
            this.errors = [];
            $("#tab-3").trigger("click");
          })
          .catch((error) => {
            if (
              error.response.status == 401 &&
              error.response.data.message == "Unauthenticated."
            )
            {
              const auth = useAuth();
              auth.clearToken();
              window.location.href = "/";
            } else if (error.response.data.errors)
            {
              console.log(error.response.data.errors);
              this.errors = error.response.data.errors;
            }
          });
        return;
      }
      this.formClinicalCase.id = this.clinicalCaseId;
      await httpauth
        .post("/casi-clinici/update", this.formClinicalCase)
        .then((response) => {
          this.successMessageFirstStep = response.data.message;
        })
        .catch((error) => {
          this.errors = error.response.data.message;
        });
    },
    async save_order() {
      var orders = [];
      $(".order_class").each(function () {
        var value = $(this).val();
        orders.push(value);
      });
      const formReorder = {
        model: "activity",
        model_id: this.clinicalCaseId,
        order: orders,
      };

      httpauth
        .post("/attachments/reorder", formReorder)
        .then((response) => {
          this.successMessageFirstStep = response.data.message;
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
    async fetchUsers() {
      await httpservices
        .getUserClinicalCase()
        .then((response) => {
          var users = response.data.data;
          this.users = users.map((user) => ({
            id: user.id,
            text: user.full_name,
          }));
          this.users.unshift({ id: "All", text: "A tutti gli utenti" });
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
    async publish() {
      if (this.attachments.length > 0)
      {
        await httpauth
          .get("/casi-clinici/closerequestcase/" + this.clinicalCaseId)
          .then((response) => {
            $("#confirm-publish").modal("hide");
            if (response.data.message == "Redirect")
            {
              localStorage.setItem("linkedincategory", "clinical-case");
              localStorage.setItem("linkedinslug", this.slug);
              location.href = response.data.data.link_redirect;
              /*router.push(
               + "/casi-clinici/" + this.slug
            );*/
            } else
            {
              localStorage.setItem(
                "messageSuccessClinicalCase",
                response.data.message
              );

              //window.location.href = "/casi-clinici";
              router.push("/casi-clinici");
            }
          })
          .catch((error) => {
            if (error.response.data.message)
            {
              this.errorMessage = error.response.data.message;
            } else
            {
              this.errorMessage =
                "Non è stato possibile pubblicare il contatta l'assistenza";
            }
          });
      } else
      {
        const $toast = useToast();
        $toast.open({
          message: "Non è possibile pubblicare il caso senza allegati",
          type: "warning",
          position: "top-right",
          // all of other options may go here
        });
        $("#confirm-publish").modal("hide");
      }
    },
    async rename(id) {
      const form = {
        id: id,
        name: document.getElementById("attachments-rename-" + id).value,
      };
      await httpauth
        .post("/attachments/rename", form)
        .then((response) => {
          const $toast = useToast();
          $toast.open({
            message: response.data.message,
            type: "info",
            position: "top-right",
            // all of other options may go here
          });
        })
        .catch((error) => {
          if (error.response.message.name[0])
          {
            const $toast = useToast();
            $toast.open({
              message: error.response.message.name[0],
              type: "danger",
              position: "top-right",
              // all of other options may go here
            });
          }
        });
    },
  },
};
</script>


<style>
.labels-files {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>